import { Switch } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { formatErrors } from '@spa/components/FormFields/helpers'
import { Controller, type Control, type FieldErrors } from 'react-hook-form'

type Props = {
  control: Control
  errors: FieldErrors
  isDisabled: boolean
}
export const NotifyUser = ({ control, errors, isDisabled }: Props) => {
  const { t } = usePlanningFormTranslation()
  return (
    <Controller
      name='notify_user'
      control={control}
      render={({ field: { value, onChange } }) => (
        <Switch
          errorMessage={formatErrors({
            inputName: 'notify_user',
            errors
          })}
          label={t('shiftForm.notifyUser')}
          name='notify_user'
          position='left'
          size='s'
          fillWidth
          onChange={onChange}
          checked={value}
          disabled={isDisabled}
        />
      )}
    />
  )
}
